import React from 'react';
import { Trans } from '@lingui/macro';

import Card from '@rover/components/src/cards/Card';
import { Flex, Heading } from '@rover/kibble/core';
import type { HomepageRebookingProfile } from '@rover/rsdk/src/apiClient/latest/model/homepageRebookingProfile';

import RebookingItems from './RebookingItems';

export type Props = {
  sitters: HomepageRebookingProfile[];
  language?: string;
};

const RebookingProfiles = ({ language, sitters = [] }: Props): JSX.Element => (
  <Card
    display="flex"
    flexDirection="column"
    flex="1 1 0"
    minHeight="100%"
    alignSelf="stretch"
    sx={{ overflow: 'hidden' }}
  >
    <Flex width="100%" flexDirection="column" flexGrow="1" minHeight={0}>
      <Heading size="300">
        <Trans>Previous pet care</Trans>
      </Heading>
      <RebookingItems language={language} sitters={sitters} />
    </Flex>
  </Card>
);

export default RebookingProfiles;
